var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsOptional, IsUUID } from 'class-validator';
import { CustomFormElementAnswerFullSizeDto } from './custom-form-element-answer.full-size.dto.js';
import { CustomFormLiteDto } from './custom-form.lite.dto.js';
export class UpdateCustomFormAnswerDto {
    customFormElementAnswerId;
    customFormElementAnswers;
    customForm;
}
__decorate([
    IsOptional(),
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], UpdateCustomFormAnswerDto.prototype, "customFormElementAnswerId", void 0);
__decorate([
    IsOptional(),
    Expose(),
    Type(() => CustomFormElementAnswerFullSizeDto),
    __metadata("design:type", Array)
], UpdateCustomFormAnswerDto.prototype, "customFormElementAnswers", void 0);
__decorate([
    IsOptional(),
    Expose(),
    Type(() => CustomFormLiteDto),
    __metadata("design:type", Function)
], UpdateCustomFormAnswerDto.prototype, "customForm", void 0);
//# sourceMappingURL=update-custom-form-answer.dto.js.map